/* global Office */
import React, { useEffect, useState } from "react";
import { getAccessToken } from "../../taskpane";
import { receiveInit, setupRouteParams, tellParent } from "../../structure/dialogBridge";
import ProjectSetup from "./ProjectSetup";

/**
 * Root of #/project-setup. In an Office dialog it waits for the token from the taskpane and
 * reports back with messageParent; outside a dialog (taskpane fallback, browser) it uses the
 * stored token and returns to the project list.
 */
export default function ProjectSetupApp() {
  const { mode, projectId, inDialog } = setupRouteParams();
  const [token, setToken] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    const ready = typeof Office !== "undefined" && Office.onReady ? Office.onReady() : Promise.resolve();
    ready
      .then(() => (inDialog ? receiveInit().then((m) => m.token) : getAccessToken()))
      .then((t) => {
        if (cancelled) return;
        if (t) setToken(t);
        else setError("სესია ვერ მოიძებნა — შედით სისტემაში დანამატიდან.");
      })
      .catch((err) => !cancelled && setError(err.message || "ფანჯარა ვერ გაიხსნა"));
    return () => {
      cancelled = true;
    };
  }, [inDialog]);

  const leave = (result) => {
    if (inDialog) tellParent(result ? { type: "done", ...result } : { type: "cancel" });
    else window.location.hash = result?.projectId ? `#/projects/${result.projectId}` : "#/projects";
  };

  if (!token) {
    return <div style={{ padding: 40, fontFamily: "Segoe UI, sans-serif", color: error ? "#b42318" : "#6a6f7e" }}>{error || "იტვირთება…"}</div>;
  }
  return <ProjectSetup token={token} mode={mode} projectId={projectId} onDone={leave} onCancel={() => leave(null)} />;
}
